{{#unless isDefaultSelected}}
    {{#each parents}}
        <li>{{this}}</li>
    {{/each}}
    <li>{{name}}</li>
{{/unless}}